module.exports = __webpack_public_path__ + "img/arrow.220de356.svg";